import React from "react";
import { FormattedMessage } from "react-intl";

const TimeSectionTimePhase = (): React.ReactElement<
  React.ComponentProps<"div">,
  "div"
> => {
  return (
    <div className="asian-event__time-section--live-phase">
      <FormattedMessage tagName="span" id="events-dashboard-live" />
    </div>
  );
};

export default TimeSectionTimePhase;
